import { render, staticRenderFns } from "./versionNumber.vue?vue&type=template&id=3d0ea04d&scoped=true&"
import script from "./versionNumber.vue?vue&type=script&lang=js&"
export * from "./versionNumber.vue?vue&type=script&lang=js&"
import style0 from "./versionNumber.vue?vue&type=style&index=0&id=3d0ea04d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0ea04d",
  null
  
)

export default component.exports